import { EnterpriseOption } from '@app/core/interfaces/enterprise-option';

export interface EnterpriseLocal {
  id?: number; // Option[Int] = None,
  resellerId: number; // Int,
  externalId?: string; // Option[String] = None,
  vpnId?: string; // Option[String] = None,
  name: string; // String,
  description: string; // String = "",
  defaultSite?: number; // Option[Int],
  contractNumber?: string; // Option[String] = None,
  customerCode?: string; // Option[String] = None,
  productOptionId?: number; // Option[Number] = None,
  allowPreviews?: boolean; // Option[Boolean] = None,
  anonymousCdr?: boolean; // Option[Boolean] = Some(true),
  adminEmail?: string; // Option[String] = None,
  adminInfo?: string; // Option[String] = None,
  initialTemplate?: string; // Option[String] = None,
  special?: number; // Option[Int] = None,
  resellerVoipSbcId?: number; // Option[Int] = None
  resellerTrunkSbcId?: number; // Option[Int] = None
  resellerTrunkRedundantSbcId?: number; // Option[Int] = None
  createdOn?: string; // Option[DateTime] = Some(DateTime.now),
  updatedOn: string; // DateTime = DateTime.now,
  blocked: boolean; //   Boolean = false,
  billable: boolean; //  Boolean = true,
  options?: EnterpriseOption[]; // Option[EnterpriseOptions] = None
  // target system where the enterprise resides
  system?: string;
  teamsPartner?: TeamsPartner; // Option[TeamsPartner.Value] = None;
  teamsPartnerId?: string; // Option[String] = None;
  teamsPartnerAccountId?: string; // Option[String] = None;
  teamsTenantDomain?: string; // Option[String] = None;
  teamsTenantId?: string; // Option[String] = None;
}

export enum TeamsPartner {
  SIPPIO = 'SIPPIO',
}

export function isTeamsPartner(e: EnterpriseLocal): boolean {
  return e.teamsPartner?.length > 0;
}
